import {
  Base,
  model,
  endpoint,
} from '@scoutgg/ftw/source/lib/model'
@model('Gamescorekeeper')
@endpoint('gamescorekeeper', { root: '/external-apis' })
export class Gamescorekeeper extends Base {

}